function initProjectQHeader(root = document) {
  const headers = [...root.querySelectorAll('.wstq-header')];
  if (root.matches?.('.wstq-header')) headers.unshift(root);
  headers.forEach((header) => {
    if (header.dataset.pqHeaderReady) return;
    header.dataset.pqHeaderReady = 'true';
    const menus = [...header.querySelectorAll('[data-pq-mega]')];
    const mobile = header.querySelector('.wstq-mobile-menu');
    const closeOthers = (current) => menus.forEach((menu) => { if (menu !== current) menu.open = false; });
    const measure = () => header.style.setProperty('--pq-browse-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    menus.forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      const sync = () => summary?.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.addEventListener('toggle', () => { if (menu.open) closeOthers(menu); sync(); });
      sync();
    });
    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const activeMenu = event.target.closest('[data-pq-mega], .wstq-mobile-menu');
      closeOthers(null);
      if (mobile) mobile.open = false;
      activeMenu?.querySelector(':scope > summary')?.focus();
    });
    header.addEventListener('click', (event) => {
      if (mobile && event.target.closest('[data-pq-wishlist-open]')) mobile.open = false;
    });
    if (mobile) {
      const summary = mobile.querySelector(':scope > summary');
      const sync = () => { summary?.setAttribute('aria-expanded', String(mobile.open)); summary?.setAttribute('aria-label', mobile.open ? window.ProjectQI18n.close_menu : window.ProjectQI18n.open_menu); if (mobile.open) { closeOthers(null); measure(); } };
      mobile.addEventListener('toggle', sync);
      sync();
    }
    const resize = () => { measure(); if (window.innerWidth >= 990 && mobile) mobile.open = false; };
    window.addEventListener('resize', resize, { passive: true });
    measure();
  });
}

document.addEventListener('DOMContentLoaded', () => initProjectQHeader());
document.addEventListener('shopify:section:load', (event) => initProjectQHeader(event.target));
